(() => {
  document.documentElement.classList.add('sw-motion');

  const reveal = () => {
    const nodes = document.querySelectorAll('.sw-reveal:not([data-sw-ready])');

    if (!('IntersectionObserver' in window)) {
      nodes.forEach((node) => node.classList.add('is-revealed'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -7% 0px'
      }
    );

    nodes.forEach((node, index) => {
      node.dataset.swReady = 'true';
      node.style.transitionDelay = `${Math.min(index % 4, 3) * 65}ms`;
      observer.observe(node);
    });
  };

  document.addEventListener('DOMContentLoaded', reveal);
  document.addEventListener('shopify:section:load', reveal);
})();
